"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEffectDebugger = void 0;
const react_1 = require("react");
const previous_hook_1 = require("./previous-hook");
function useEffectDebugger(effectHook, dependencies, dependencyNames = []) {
    const previousDeps = (0, previous_hook_1.usePrevious)(dependencies, []);
    const changedDeps = dependencies.reduce((accum, dependency, index) => {
        if (dependency !== previousDeps[index]) {
            const keyName = dependencyNames[index] || index;
            return {
                ...accum,
                [keyName]: {
                    before: previousDeps[index],
                    after: dependency,
                },
            };
        }
        return accum;
    }, {});
    if (Object.keys(changedDeps).length) {
        console.log('[use-effect-debugger] ', changedDeps);
    }
    (0, react_1.useEffect)(effectHook, dependencies);
}
exports.useEffectDebugger = useEffectDebugger;
//# sourceMappingURL=debugger-effect.js.map